export const onEnterSearch = (e, setSearchText, handleSearch) => {
  if (e.key === 'Enter') {
    setSearchText(e.target.value)
    handleSearch(e.target.value)
  }
}
